import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setServiceType } from "../redux/actions/serviceTypeActions";
import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";

// const ServiceTypeSelector = () => {
//   const dispatch = useDispatch();
//   const {serviceType} = useSelector((state) => state.serviceType.serviceType);
  

//   console.log("serviceType",serviceType)

//   const handleChange = (e) => {
//     dispatch(setServiceType(e.target.value));
//   };

//   return (
//     <Box
//       sx={{
//         display: "flex",
//         alignItems: "center",
//         marginLeft: 2,
//         marginRight: 2,
//         backgroundColor: "#b6bacc",
//         borderRadius: 1,
//         boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
//         paddingX: 1,
//       }}
//     >
//       <FormControl
//         variant="outlined"
//         size="small"
//         sx={{
//           minWidth: 120,
//           "& .MuiOutlinedInput-notchedOutline": {
//             borderColor: "transparent",
//           },
//           "&:hover .MuiOutlinedInput-notchedOutline": {
//             borderColor: "#1e40af",
//           },
//           "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
//             borderColor: "#1e40af",
//           },
//         }}
//       >
//         {/* <InputLabel id="service-type-label">Service Type</InputLabel> */}
//         <Select
//           labelId="service-type-label"
//           value={serviceType}
//           onChange={handleChange}
//         //   label="Service Type"
//           sx={{
//             "& .MuiSelect-icon": {
//               color: "#1e40af",
//             },
//           }}
//         >
//           <MenuItem value="Auto">Auto</MenuItem>
//           <MenuItem value="TourPackage">Tour Package</MenuItem>
//         </Select>
//       </FormControl>
//     </Box>
//   );
// };


const ServiceTypeSelector = () => {
  const dispatch = useDispatch();
  const { serviceType } = useSelector((state) => state.serviceType.serviceType);

  const handleChange = (e) => {
    dispatch(setServiceType(e.target.value));
  };

  // return (
  //   <Box
  //     sx={{
  //       display: "flex",
  //       alignItems: "center",
  //       width: {
  //         xs: "50%", // full width on extra-small screens
  //         sm: "auto"  // auto on small and up
  //       },
  //       backgroundColor: "#b6bacc",
  //       borderRadius: 1,
  //       boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
  //       px: 1
  //     }}
  //   >
  //     <FormControl
  //       fullWidth
  //       variant="outlined"
  //       size="small"
  //       sx={{
  //         "& .MuiOutlinedInput-notchedOutline": {
  //           borderColor: "transparent",
  //         },
  //         "&:hover .MuiOutlinedInput-notchedOutline": {
  //           borderColor: "#1e40af",
  //         },
  //         "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
  //           borderColor: "#1e40af",
  //         },
  //       }}
  //     >
  //       <Select
  //         labelId="service-type-label"
  //         value={serviceType}
  //         onChange={handleChange}
  //         sx={{
  //           "& .MuiSelect-icon": {
  //             color: "#1e40af",
  //           },
  //         }}
  //       >
  //         <MenuItem value="Auto">Auto</MenuItem>
  //         <MenuItem value="TourPackage">Tour Package</MenuItem>
  //       </Select>
  //     </FormControl>
  //   </Box>
  // );


  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        width: {
          xs: "100%", 
          sm: "auto" 
        },
        maxWidth: { xs: "200px", sm: "none" }, // Added max-width for mobile
        backgroundColor: "#b6bacc",
        borderRadius: 1,
        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
        px: 1,
      }}
    >
      <FormControl
        fullWidth
        variant="outlined"
        size="small"
        sx={{
          minWidth: 120, // Set minimum width
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "transparent",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#1e40af",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#1e40af",
          },
        }}
      >
        <Select
          labelId="service-type-label"
          value={serviceType}
          onChange={handleChange}
          sx={{
            fontSize: { xs: "0.875rem", sm: "1rem" }, // Smaller font on mobile
            "& .MuiSelect-icon": {
              color: "#1e40af",
            },
          }}
        >
          <MenuItem value="Auto" sx={{ fontSize: { xs: "0.875rem", sm: "1rem" } }}>Auto</MenuItem>
          <MenuItem value="TourPackage" sx={{ fontSize: { xs: "0.875rem", sm: "1rem" } }}>Tour Package</MenuItem>
          <MenuItem value="Tracking" sx={{ fontSize: { xs: "0.875rem", sm: "1rem" } }}>Tracking</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );



  

};


export default ServiceTypeSelector;
